import bcrypt from 'bcryptjs' //https://openbase.com/js/bcryptjs/documentation

export const hashPassword = (password) => {
    //const salt = bcrypt.genSaltSync(15) //generate new salt
    const salt = "$2a$15$Q6/rNhjyYxJ1FV.YsOKaO.R"; //Guardar en variable de entorno
    return bcrypt.hash(password, salt) 
}